import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myNewsListFilterState = atom({
  key: "myNewsListFilterState",
  default: "current",
  effects_UNSTABLE: [ocPersistAtom],
});
